import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { MENU_STATES, SET_MENU_STATE, CUSTOM_STATE_CHANGE_TYPES } from './constants';
import { noop } from 'lodash';
export var getCustomDownshift = function getCustomDownshift(_ref) {
  var downshift = _ref.downshift,
      items = _ref.items,
      fixtures = _ref.fixtures,
      fixtureActions = _ref.fixtureActions,
      menuState = _ref.menuState,
      dispatch = _ref.dispatch,
      propOnFocus = _ref.propOnFocus,
      filter = _filterInstanceProperty(_ref),
      shouldOpenOnInputFocus = _ref.shouldOpenOnInputFocus,
      shouldBackspaceRemove = _ref.shouldBackspaceRemove,
      shouldDeleteRemove = _ref.shouldDeleteRemove,
      shouldAddFreeformValue = _ref.shouldAddFreeformValue,
      shouldBlurResetInput = _ref.shouldBlurResetInput,
      freeformValueNormalizer = _ref.freeformValueNormalizer,
      setMenuState = _ref.setMenuState,
      setStateChangeAction = _ref.setStateChangeAction;

  var isOpen = downshift.isOpen,
      inputValue = downshift.inputValue,
      selectedItem = downshift.selectedItem,
      highlightedIndex = downshift.highlightedIndex,
      openMenu = downshift.openMenu,
      selectItem = downshift.selectItem,
      setState = downshift.setState,
      setItemCount = downshift.setItemCount,
      _getRootProps = downshift.getRootProps,
      getItemProps = downshift.getItemProps,
      _getInputProps = downshift.getInputProps,
      _getToggleButtonProps = downshift.getToggleButtonProps;
  var filteredItems = filter(items, inputValue, selectedItem);
  setItemCount(filteredItems.length + fixtures.length); // Make sure that the menu state correctly reflects the state of the filtered
  // items rather than just the items

  if (filteredItems.length <= 0 && menuState === MENU_STATES.HAS_ITEMS) {
    dispatch({
      type: SET_MENU_STATE,
      payload: MENU_STATES.NO_RESULTS_FOUND
    });
  } else if (filteredItems.length > 0 && menuState === MENU_STATES.NO_RESULTS_FOUND) {
    dispatch({
      type: SET_MENU_STATE,
      payload: MENU_STATES.HAS_ITEMS
    });
  }

  var createFocusHandler = function createFocusHandler(onFocus) {
    return function (event) {
      if (shouldOpenOnInputFocus) {
        if (!isOpen) {
          openMenu();
        }
      }

      onFocus(event);
      propOnFocus(event);
    };
  };

  var createKeyDownHandler = function createKeyDownHandler(onKeyDown) {
    return function (event) {
      if (shouldBackspaceRemove && event.key === 'Backspace' && (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) <= 0) {
        setState({
          selectedItem: null,
          // TODO: Fix type
          // eslint-disable-next-line
          // @ts-ignore
          type: CUSTOM_STATE_CHANGE_TYPES.BACKSPACE_REMOVE
        });
      }

      if (shouldDeleteRemove && event.key === 'Delete') {
        setState({
          selectedItem: null,
          inputValue: '',
          // TODO: Fix type
          // eslint-disable-next-line
          // @ts-ignore
          type: CUSTOM_STATE_CHANGE_TYPES.DELETE_REMOVE
        });
      }

      if (event.key === 'Enter') {
        if (!isOpen) {
          openMenu();
        } // Fixtures should always be at the end of the menu after all of
        // the filtered items


        if (highlightedIndex && highlightedIndex >= filteredItems.length) {
          var _fixtureActions$curre, _fixtureActions$curre2;

          var normalizedIndex = highlightedIndex - filteredItems.length;
          (_fixtureActions$curre = (_fixtureActions$curre2 = fixtureActions.current)[normalizedIndex]) === null || _fixtureActions$curre === void 0 ? void 0 : _fixtureActions$curre.call(_fixtureActions$curre2);
        } else if (highlightedIndex === null && shouldAddFreeformValue && event.target.value) {
          selectItem(freeformValueNormalizer(event.target.value), {
            // TODO: Fix type
            // eslint-disable-next-line
            // @ts-ignore
            type: CUSTOM_STATE_CHANGE_TYPES.ADD_FREEFORM_VALUE
          });
        }
      }

      onKeyDown(event);
    };
  };

  var customDownshift = _objectSpread(_objectSpread({}, downshift), {}, {
    // Custom render props
    items: filteredItems,
    menuState: menuState,
    setMenuState: setMenuState,
    setStateChangeAction: setStateChangeAction,
    // Spreading this onto our fixtures will make it so that downshift can treat
    // them like regular items (for a11y) but we can ignore selection events
    getFixtureProps: function getFixtureProps() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref2$onClick = _ref2.onClick,
          _onClick = _ref2$onClick === void 0 ? noop : _ref2$onClick,
          fixtureProps = _objectWithoutProperties(_ref2, ["onClick"]);

      // TODO: Fix type
      // eslint-disable-next-line
      // @ts-ignore
      var _fixtureProps$index = fixtureProps.index,
          index = _fixtureProps$index === void 0 ? filteredItems.length : _fixtureProps$index;
      var normalizedIndex = index - filteredItems.length;
      return getItemProps(_objectSpread(_objectSpread({
        index: index
      }, fixtureProps), {}, {
        item: {
          fixture: true
        },
        // TODO: Fix type
        // eslint-disable-next-line
        // @ts-ignore
        setFixtureAction: function setFixtureAction(onFixtureAction) {
          if (typeof onFixtureAction === 'function') {
            fixtureActions.current[normalizedIndex] = onFixtureAction;
          } else {
            throw new Error("You must pass a function to 'setFixtureAction'");
          }
        },
        onClick: function onClick(event) {
          var _fixtureActions$curre3, _fixtureActions$curre4;

          (_fixtureActions$curre3 = (_fixtureActions$curre4 = fixtureActions.current)[normalizedIndex]) === null || _fixtureActions$curre3 === void 0 ? void 0 : _fixtureActions$curre3.call(_fixtureActions$curre4);

          _onClick(event);
        }
      }));
    },
    // Downshift render props
    getRootProps: function getRootProps(rootProps, options) {
      return _getRootProps(rootProps, _objectSpread(_objectSpread({}, options), {}, {
        suppressRefError: true
      }));
    },
    // Input
    getInputProps: function getInputProps() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref3$onFocus = _ref3.onFocus,
          onFocus = _ref3$onFocus === void 0 ? noop : _ref3$onFocus,
          _ref3$onKeyDown = _ref3.onKeyDown,
          onKeyDown = _ref3$onKeyDown === void 0 ? noop : _ref3$onKeyDown,
          _ref3$onBlur = _ref3.onBlur,
          _onBlur = _ref3$onBlur === void 0 ? noop : _ref3$onBlur,
          _ref3$onClick = _ref3.onClick,
          _onClick2 = _ref3$onClick === void 0 ? noop : _ref3$onClick,
          inputProps = _objectWithoutProperties(_ref3, ["onFocus", "onKeyDown", "onBlur", "onClick"]);

      return _getInputProps(_objectSpread(_objectSpread({}, inputProps), {}, {
        onFocus: createFocusHandler(onFocus),
        onKeyDown: createKeyDownHandler(onKeyDown),
        onBlur: function onBlur(event) {
          if (shouldBlurResetInput && inputValue) {
            setState({
              inputValue: '',
              // TODO: Fix type
              // eslint-disable-next-line
              // @ts-ignore
              type: CUSTOM_STATE_CHANGE_TYPES.BLUR_RESET
            });
          } // Not totally certain on the UX of adding freeform values
          // onBlur yet
          // Remove if we decide not to include this functionality
          // if (shouldAddFreeformValue && event.target.value) {
          //   selectItem(freeformValueNormalizer(event.target.value), {
          //     type: CUSTOM_STATE_CHANGE_TYPES.ADD_FREEFORM_VALUE
          //   });
          // }


          _onBlur(event);
        },
        onClick: function onClick(event) {
          // When the user clicks on the input, we want to open the menu either through
          // the focus behaviour (see above) or through the click behaviour, so we always
          // check here as a fallback
          if (!isOpen) {
            openMenu();
          }

          _onClick2(event);
        }
      }));
    },
    // Toggle button
    getToggleButtonProps: function getToggleButtonProps() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref4$onFocus = _ref4.onFocus,
          onFocus = _ref4$onFocus === void 0 ? noop : _ref4$onFocus,
          _ref4$onKeyDown = _ref4.onKeyDown,
          onKeyDown = _ref4$onKeyDown === void 0 ? noop : _ref4$onKeyDown,
          _ref4$onClick = _ref4.onClick,
          _onClick3 = _ref4$onClick === void 0 ? noop : _ref4$onClick,
          toggleButtonProps = _objectWithoutProperties(_ref4, ["onFocus", "onKeyDown", "onClick"]);

      return _getToggleButtonProps(_objectSpread(_objectSpread({}, toggleButtonProps), {}, {
        onFocus: createFocusHandler(onFocus),
        onKeyDown: createKeyDownHandler(onKeyDown),
        onClick: function onClick(event) {
          _onClick3(event);
        }
      }));
    }
  });

  return customDownshift;
};